module.exports = __webpack_public_path__ + "static/media/picture.e5a80df0.svg";